import { requestApi } from "../axios";

export function loginService(email, password, remember) {
  return requestApi(`/admin/auth/login`, "POST", { username: email, password: password, remember: remember });
}

export function loginViaADFS(code, client_id) {
  return requestApi(`/admin/auth/login-adfs`, "POST", { code, client_id });
}

export function register(formData) {
  return requestApi(`/admin/auth/register`, "POST", {
    username: formData.email,
    fullname: formData.fullname,
    password: formData.password,
    captchaToken: formData.captchaToken,
  });
}

export function verifyToken(token) {
  return requestApi(`/admin/auth/verification?token=${token}`, "GET");
}

export function requestResetPassword(email) {
  return requestApi(`/admin/auth/send-mail-reset`, "POST", { email });
}

export function resetPassword(password, token) {
  return requestApi(`/admin/auth/reset-pass`, "POST", { password, token });
}
